// extracted by mini-css-extract-plugin
module.exports = {"root":"v0RQQz","buyer-note-divider":"iJoCCT","buyerNoteDivider":"iJoCCT","divider":"Dl1ucB","totalRowDivider":"N7J0WU","section":"adDAwa","buyerNote":"o2ZyWI","totals":"aNdpCM"};